import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLoaderData, useNavigation, useSearchParams } from 'react-router-dom';
import Logo from 'src/components/Logo';
import Page from 'src/components/Page';
import { StyledLoading } from 'src/components/app-components/StyledLoading';
import { IdIssuanceForm } from '../components/IdIssuanceForm';
import { LanguageSelector } from '../components/LanguageSelector';
import { VerifyTokenResponse } from '../routes/idIssuanceRoute';

export const IdIssuancePage = () => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { organizations } = useLoaderData() as VerifyTokenResponse;

  if (isLoading) {
    return <StyledLoading isOpen={isLoading} />;
  }

  return (
    <Page title={t('idIssuance.pageTitle')}>
      <Container component="main" maxWidth="md" sx={{ width: '50%', p: 16 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Logo sx={{ width: '50px', height: '50px' }} />
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: '400',
              fontStyle: 'normal',
              fontFamily: 'Nunito',
            }}>
            BONSAI
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>Global Data Collector</Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <LanguageSelector />
        </Box>
        <IdIssuanceForm token={token} organizations={organizations} />
      </Container>
    </Page>
  );
};
